/**
 * Class description
 *
 * Created: 2019-08-13
 * @author jonas
 */

import {WinterHoardLayerConfig} from "../config/WinterHoardLayerConfig";
import {BasicBitmapCountUp} from "../display/BasicBitmapCountUp";
import {WinterHoardTextStyles} from "../config/WinterHoardTextStyles";
import {Ease, Linear, TimelineLite, TweenLite} from "gsap";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinterHoardSoundConfig} from "../WinterHoardSoundConfig";
import {SoundPlayer} from "../sound/SoundPlayer";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {WinterHoardGameConfig} from "../WinterHoardGameConfig";

export class CountUpView extends BaseView {
    private _layer:ScalableLayer;
    private _bitmapText:BasicBitmapCountUp;
    private _soundPlaying:boolean = false;
    private _sparkle:PIXI.spine.Spine;

    constructor() {
        super();
        this._layer = StageManager.getLayer(WinterHoardLayerConfig.WIN_COUNT_UP.name);
    }

    protected initAnimations():void {
        this._bitmapText = new BasicBitmapCountUp(WinterHoardTextStyles.WIN_COUNT_UP, 720, new PIXI.Point(0.5, 0.5));
        this._bitmapText.position.set(360, 360);
        this._sparkle = new PIXI.spine.Spine(GameResources.getSpineAsset("countUpSparkle"));
        this._sparkle.position.set(360, 330);
        this._sparkle.scale.set(2, 2);
        this._sparkle.alpha = 0.5;
        this._sparkle.renderable = false;
        this.addChild(this._bitmapText);
        this.addChild(this._sparkle);
    }

    public calculateTextScale(from:number, to:number){
        this._bitmapText.preCalculateScale(from, to);
    }

    public getWinStepAnimation(from:number, to:number, duration:number, ease:Ease = Linear.easeNone, position:number[] = [360, 360]):TimelineLite {
        //this._bitmapText.preCalculateScale(from, to);
        const tl:TimelineLite = new TimelineLite();
        this._bitmapText.position.set(position[0], position[1]);
        this._sparkle.position.set(position[0], position[1]-30);
        tl.add(() => {
            if(!WinterHoardGameConfig.instance.WIN_BELOW_STAKE)
            this._layer.addChild(this);
            // #287
            !WinterHoardGameConfig.instance.WIN_BELOW_STAKE && this.startCountUpSound();
        });
        tl.add(this._bitmapText.getCountAnimation(from, to, duration, ease));

        return tl;
    }

    public abort(value:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => this._bitmapText.stopAt(value));
        return tl;
    }


    public end(value:number, displayDuration:number, fadeDuration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {

            if(!WinterHoardGameConfig.instance.WIN_BELOW_STAKE)
            this._layer.addChild(this);

            // #287
            !WinterHoardGameConfig.instance.WIN_BELOW_STAKE && this.stopCountUpSound();
            this._bitmapText.stopAt(value);
            // #287
            if (!WinterHoardGameConfig.instance.WIN_BELOW_STAKE) {
                this._sparkle.renderable = true;
                this._sparkle.state.setAnimation(0, "countup_spark", false);
                SoundPlayer.playEffect(WinterHoardSoundConfig.COUNT_UP_END);
            }
            SlotGame.winFieldController.showWinField();
        },0);
        tl.add(() => this.fadeAndRemove(fadeDuration), displayDuration);
        return tl;
    }


    private fadeAndRemove(fadeDuration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(new TweenLite(this, fadeDuration, {alpha : 0, ease : Linear.easeNone}));
        tl.add(() => {
            this._sparkle.renderable = false;
            this._layer.removeChild(this);
            this.alpha = 1;
        });
        return tl;
    }


    private startCountUpSound() {
        if(!this._soundPlaying) {
            SoundPlayer.playEffect(WinterHoardSoundConfig.COUNT_UP_LOOP, Infinity);
            this._soundPlaying = true;
        }
    }

    private stopCountUpSound() {
        if(this._soundPlaying) {
            SoundPlayer.stopSound(WinterHoardSoundConfig.COUNT_UP_LOOP);
            this._soundPlaying = false;
        }
    }
}